// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"cookiesInfo_wrapper__yh64Q","logo":"cookiesInfo_logo__2xwwI","teamViewer":"cookiesInfo_teamViewer__2KNPj","itemWrapper":"cookiesInfo_itemWrapper__1bfBU"};